import type { RouteObject } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import DualScreenPage from '../pages/mossteams/dual-screen/page';
import DesktopClientPage from '../pages/mossteams/desktop-client/page';
import OfflineVoiceBoxPage from '../pages/mossteams/offline-voice-box/page';
import MossAppPage from '../pages/mossteams/app/page';
import StandardPage from '../pages/mosstalk/standard/page';
import BusinessPage from '../pages/mosstalk/business/page';
import EarbudsPage from '../pages/mosstalk/earbuds/page';
import SubtitleProPage from '../pages/mossvox/subtitle-pro/page';
import RecorderPage from '../pages/mossvox/recorder/page';
import AllInOnePage from '../pages/more-products/all-in-one/page';
import CasesPage from '../pages/support/cases/page';
import CaseInfoPage from '../pages/support/cases/info/page';
import DownloadsPage from '../pages/support/downloads/page';
import ContactPage from '../pages/contact/page';
import PrivacyPolicyPage from '../pages/mossaura/privacy-policy/page';
import UserAgreementPage from '../pages/mossaura/user-agreement/page';

const routes: RouteObject[] = [
  { path: '/mossaura/privacy-policy', element: <PrivacyPolicyPage /> },
  { path: '/mossaura/user-agreement', element: <UserAgreementPage /> },
  {
    element: <Layout />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/mossteams/dual-screen', element: <DualScreenPage /> },
      { path: '/mossteams/desktop-client', element: <DesktopClientPage /> },
      { path: '/mossteams/offline-voice-box', element: <OfflineVoiceBoxPage /> },
      { path: '/mossteams/app', element: <MossAppPage /> },
      { path: '/mosstalk/standard', element: <StandardPage /> },
      { path: '/mosstalk/business', element: <BusinessPage /> },
      { path: '/mosstalk/earbuds', element: <EarbudsPage /> },
      { path: '/mossvox/subtitle-pro', element: <SubtitleProPage /> },
      { path: '/mossvox/recorder', element: <RecorderPage /> },
      { path: '/more-products/all-in-one', element: <AllInOnePage /> },
      { path: '/support/cases', element: <CasesPage /> },
      { path: '/support/cases/:newsId', element: <CaseInfoPage /> },
      { path: '/support/downloads', element: <DownloadsPage /> },
      { path: '/contact', element: <ContactPage /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];

export default routes;